export default "__VITE_ASSET__3EtJO2bd__"